import React, { useEffect } from "react";
import "./Privacy.scss";
import Header from "../../../components/header/Header";

const Privacy = () => {
  useEffect(() => {}, []);

  return (
    <div className="privacy-container">
      <Header showNavigation={false} />
      <div className="privacy-content">
        <div className="privacy-header">
          <h1 className="privacy-title">Privacy Statement</h1>
          <p className="privacy-subtitle">
            Information in accordance with Section 5 TMG and GDPR
          </p>
        </div>
        <div className="privacy-info">
          <p className="info-heading">Personal Data Processing</p>
          <p className="info-text">
            Personal data (usually referred to just as “data” below) will only
            be processed by me to the extent necessary and for the purpose of
            providing a functional and user-friendly website, including its
            contents, and the services offered there.
          </p>
          <p className="info-text">
            Per Art. 4 No. 1 of Regulation (EU) 2016/679, i.e. the General Data
            Protection Regulation (hereinafter referred to as the “GDPR”),
            “processing” refers to any operation or set of operations such as
            collection, recording, organization, structuring, storage,
            adaptation, alteration, retrieval, consultation, use, disclosure by
            transmission, dissemination, or otherwise making available,
            alignment, or combination, restriction, erasure, or destruction
            performed on personal data, whether by automated means or not.
          </p>
          <p className="info-text">
            The following privacy policy is intended to inform you in particular
            about the type, scope, purpose, duration, and legal basis for the
            processing of such data either under my own control or in
            conjunction with others. I also inform you below about the
            third-party components I use to optimize my website and improve the
            user experience which may result in said third parties also
            processing data they collect and control.
          </p>

          <p className="info-heading">
            I. Information about me as controllers of your data
          </p>
          <p className="info-text">
            The party responsible for this website (the “controller”) for
            purposes of data protection law is:
          </p>
          <p className="info-text">
            <strong>Simon Kobler</strong>
            <br />
            Bürgermeister-Wild-Straße 33a
            <br />
            85521 Ottobrunn
            <br />
            Germany
            <br />
            Email: <a href="mailto:portfolio@kobler.me">portfolio@kobler.me</a>
          </p>
          <p className="info-text">Data protection officer: Simon Kobler</p>

          <p className="info-heading">
            II. The rights of users and data subjects
          </p>
          <p className="info-text">
            With regard to the data processing to be described in more detail
            below, users and data subjects have the right to:
          </p>
          <ul>
            <li>
              To confirmation of whether data concerning them is being
              processed, information about the data being processed, further
              information about the nature of the data processing, and copies of
              the data (cf. also Art. 15 GDPR);
            </li>
            <li>
              To correct or complete incorrect or incomplete data (cf. also Art.
              16 GDPR);
            </li>
            <li>
              To the immediate deletion of data concerning them (cf. also Art.
              17 DSGVO), or, alternatively, if further processing is necessary
              as stipulated in Art. 17 Para. 3 GDPR, to restrict said processing
              per Art. 18 GDPR;
            </li>
            <li>
              To receive copies of the data concerning them and/or provided by
              them and to have the same transmitted to other
              providers/controllers (cf. also Art. 20 GDPR);
            </li>
            <li>
              To file complaints with the supervisory authority if they believe
              that data concerning them is being processed by the controller in
              breach of data protection provisions (see also Art. 77 GDPR).
            </li>
          </ul>
          <p className="info-text">
            Users and data subjects have the right to object to the controller’s
            future processing of their data pursuant to Art. 6 Para. 1 lit. f)
            GDPR, particularly regarding processing for direct advertising
            purposes.
          </p>

          <p className="info-heading">
            III. Information about the data processing
          </p>
          <p className="info-text">
            Your data processed when using my website will be deleted or blocked
            as soon as the purpose for its storage ceases to apply, provided the
            deletion of the same is not in breach of any statutory storage
            obligations or unless otherwise stipulated below.
          </p>

          <p className="info-heading">Server Data</p>
          <p className="info-text">
            For technical reasons, the following data sent by your internet
            browser to me or to my server provider will be collected: These
            server log files record the type and version of your browser,
            operating system, the website from which you came (referrer URL),
            the webpages on my site visited, the date and time of your visit, as
            well as the IP address from which you visited my site.
          </p>

          <p className="info-heading">Cookies</p>
          <p className="info-text">
            I use cookies on my website. Cookies are small text files or other
            storage technologies stored on your computer by your browser. These
            cookies process certain specific information about you, such as your
            browser, location data, or IP address.
          </p>
          <p className="info-text">
            The legal basis for such processing is Art. 6 Para. 1 lit. b) GDPR,
            insofar as these cookies are used to collect data to initiate or
            process contractual relationships. If the processing does not serve
            to initiate or process a contract, my legitimate interest lies in
            improving the functionality of my website. The legal basis is then
            Art. 6 Para. 1 lit. f) GDPR.
          </p>

          <p className="info-heading">Contact</p>
          <p className="info-text">
            If you contact me via email or the contact form, the data you
            provide will be used for the purpose of processing your request.
          </p>

          <p className="info-heading">Google Analytics</p>
          <p className="info-text">
            This website uses Google Analytics, a web analytics service provided
            by Google Inc. ("Google"). Google Analytics uses cookies to help
            analyze how users use the site. The information generated by the
            cookie about your use of the website (including your IP address) is
            transmitted to Google servers in the United States and stored there.
            Google will use this information to evaluate your use of the
            website, compiling reports on website activity for website operators
            and providing other services related to website activity and
            internet usage.
          </p>
          <p className="info-text">
            You may refuse the use of cookies by selecting the appropriate
            settings on your browser, but please note that if you do this, you
            may not be able to use the full functionality of this website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
